import { PlansTab } from "../../plans/UniversalPlansBox";

const RpcEndpointsPlansTab = () => {
  const rpcServiceType = Number(import.meta.env.VITE_RPC_SERVICE_TYPE) || 1;
  return (
    <>
      <PlansTab serviceType={rpcServiceType} />
    </>
  );
};

export default RpcEndpointsPlansTab;
